(function () {
  /* =========================================================
     WALLET BUTTON SWITCHER

     Apple devices:
       -> Show Apple Pay
       -> Hide Shop Pay
       -> Hide Google Pay
       -> Hide PayPal

     Non-Apple devices:
       -> Show Shop Pay
       -> Hide Apple Pay
       -> Hide Google Pay
       -> Hide PayPal
     ========================================================= */

  const userAgent = navigator.userAgent || '';

  const isAppleDevice =
    /iPhone|iPad|iPod|Macintosh/i.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  /* -------------------------------------------------------
     Add device class
     ------------------------------------------------------- */

  document.documentElement.classList.toggle(
    'is-apple-device',
    isAppleDevice
  );

  document.documentElement.classList.toggle(
    'is-non-apple-device',
    !isAppleDevice
  );

  /* -------------------------------------------------------
     Add CSS
     ------------------------------------------------------- */

  const STYLE_ID = 'wallet-button-device-css';

  const existingStyle = document.getElementById(STYLE_ID);

  if (existingStyle) {
    existingStyle.remove();
  }

  const style = document.createElement('style');

  style.id = STYLE_ID;

  style.textContent = `

    /* =====================================================
       ALWAYS HIDE GOOGLE PAY
       ===================================================== */

    shopify-google-pay-button {
      display: none !important;
    }


    /* =====================================================
       ALWAYS HIDE PAYPAL
       ===================================================== */

    shopify-paypal-button {
      display: none !important;
    }


    /* =====================================================
       APPLE DEVICE
       Hide Shop Pay
       ===================================================== */

    html.is-apple-device shop-pay-wallet-button {
      display: none !important;
    }


    /* =====================================================
       NON-APPLE DEVICE
       Hide Apple Pay
       ===================================================== */

    html.is-non-apple-device shopify-apple-pay-button,
    html.is-non-apple-device apple-pay-button {
      display: none !important;
    }

  `;

  document.head.appendChild(style);
})();